

const QuestionsAndAnswer = [
{  id:'0',
    question: "1. What is the purpose of a subnet mask in networking?",
    option: ["A) To identify the network and host portions of an IP address"," B) To determine the broadcast address","C) To assign IP addresses automatically","D) To translate IP addresses into MAC addresses"],
    answer: "A) To identify the network and host portions of an IP address"
    
}
,

{ id:'1',
    question: "2. If an IP address is 192.168.1.25 with a subnet mask of 255.255.255.0, what is the network ID?",
    option: ["A) 192.168.1.0","B) 192.168.1.25","C) 192.168.1.255","D) 192.168.0.0"],
    answer: "A) 192.168.1.0"
}
,

{
    id:'2',
    question: "3. What does CIDR stand for, and why was it introduced?",
    option: ["A) Classless Inter-Domain Routing; to replace classful addressing with more efficient IP address allocation","B) Circuit Identification Routing; to improve communication between subnets","C) Code Identification Routing; to handle larger networks","D) Classful Identification Routing; to maintain rigid IP address class structures"],
    answer: "A) Classless Inter-Domain Routing; to replace classful addressing with more efficient IP address allocation"
}
,
{ id:'3',
    question: "4. Given a subnet mask of 255.255.255.240, what is the corresponding CIDR notation?",
    option: ["A) /28","B) /24","C) /32","D) /29"],
    answer: "A) /28"
}
,
{ id:'4',
    question: "5. Which class of IP address has a default subnet mask of 255.255.0.0?",
    option: ["A) Class A","B) Class B","C) Class C","D) Class D"],
    answer: "A) /28"

}
,
{ id:'5',
    question: "6. If two IP addresses have the same network ID but different host IDs, are they in the same subnet?",
    option: ["A) Yes","B) No"],
    answer: "A) Yes"

}
,
{ id:'6',
    question: "7. What is the maximum number of usable hosts in a subnet with CIDR notation /29?",
    option: [" A) 8","B) 4","C) 6","D) 2"],
    answer: "C) 6"

}
,
{ id:'7',
    question: "8. In the IP address 172.16.0.75/16, what part of the address represents the host portion?",
    option: ["A) 172.16","B) 0.75","C) 172","D) 16"],
    answer: "A) 172.16"
}
]

export default QuestionsAndAnswer